/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Philosophy16Inputs */

const en__field__enum_studyprograms_study_philosophy16 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Philosophy16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophy`)
};

const de__field__enum_studyprograms_study_philosophy16 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Philosophy16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Philosophie`)
};

/**
* | output |
* | --- |
* | "Philosophy" |
*
* @param {_Field__Enum_Studyprograms_Study_Philosophy16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_philosophy16 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Philosophy16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Philosophy16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_philosophy16(inputs)
	return de__field__enum_studyprograms_study_philosophy16(inputs)
});
export { _field__enum_studyprograms_study_philosophy16 as "_field__enum_studyPrograms_STUDY_PHILOSOPHY" }